import { Component, Prop, State, h, Host, Method } from '@stencil/core';

@Component({
  tag: 'dda-accordion',
  styleUrls: ['dda-accordion.css'],
  shadow: false,
})
export class DdaAccordion {
  @Prop() design: 'bg-border' | 'no-border' = 'bg-border';
  @Prop() header_text: string = 'Accordion Header';
  @Prop() sub_title: string = '';
  @Prop() body_description: string = '';
  @Prop() custom_class?: string = '';
  @Prop() link_button_text?: string = '';
  @Prop() component_mode?: string;
  @Prop() accordion_icon_class?: string = '';
  @Prop() accordion_icon_text: string = '';
  @Prop() accordion_header_end_icon: string = '';
  @Prop() accordion_id: string = '';

  @Prop() default_open: boolean = false;

  @State() isOpen: boolean;

  componentWillLoad() {
    this.isOpen = this.default_open;
  }

  toggleAccordion() {
    this.isOpen = !this.isOpen;
  }

  @Method() async openAccordion() {
    this.isOpen = true;
  }

  @Method() async closeAccordion() {
    this.isOpen = false;
  }

  @Method() async getIsOpen() {
    return this.isOpen;
  }

  onHeaderEndIconClick(event: Event) {
    event.stopPropagation();
    console.log('Header end icon clicked');
  }

  render() {
    return (
      <Host>
        <div class={`accordion-container ${this.design} ${this.custom_class} ${this.component_mode}`}>
          <div class="accordion-header" id={this.accordion_id} onClick={() => this.toggleAccordion()}>
            <div class="header-content">
              {this.accordion_icon_text ? <i class={this.accordion_icon_class}>{this.accordion_icon_text}</i> : null}
              {this.header_text ? 
                <span class="header-text">{this.header_text} 
                  <i 
                    class={`body material-flat-icon ${this.accordion_icon_class}`}
                    onClick={(event) => this.onHeaderEndIconClick(event)}
                    >
                    {this.accordion_header_end_icon}
                  </i>
                </span> 
              : null}
            </div>
            <i class={`material-icons arrow-icon`} aria-hidden="true" >{this.isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
          </div>
          <div class={this.isOpen ? 'accordion-body' : 'dda-d-none'}>
            <div class="dda-d-flex dda-flex-column dda-gap-lg">
              <div class="dda-d-flex dda-flex-column dda-gap-xs">
                {this.sub_title ? <p class="subtitle">{this.sub_title}</p> : null}
                {this.body_description ? <p class="body-description">{this.body_description}</p> : null}
              </div>
              {this.link_button_text ? (
                <dda-link-button
                  button_color="default-link"
                  end_icon="arrow_forward"
                  custom_class=""
                  link_button_text={this.link_button_text}
                  href=""
                  component_mode=""
                  button_id="link-button"
                  aria_label="link-Button"
                ></dda-link-button>
              ) : null}
              <slot></slot>
            </div>
            
          </div>
        </div>
      </Host>
    );
  }
}
